export default {
    userUid: "",
    userInfos: {},
    userTodos: {},

}